import { render, staticRenderFns } from "./DfTextField.vue?vue&type=template&id=8f6985f0&scoped=true&"
import script from "./DfTextField.vue?vue&type=script&lang=js&"
export * from "./DfTextField.vue?vue&type=script&lang=js&"
import style0 from "./DfTextField.vue?vue&type=style&index=0&id=8f6985f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6985f0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f6985f0')) {
      api.createRecord('8f6985f0', component.options)
    } else {
      api.reload('8f6985f0', component.options)
    }
    module.hot.accept("./DfTextField.vue?vue&type=template&id=8f6985f0&scoped=true&", function () {
      api.rerender('8f6985f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfTextField.vue"
export default component.exports